<template>
	<main v-editable="blok">
		<PageHeaderGeneral
			:blok="blok"
			:title="!isLotteryActive && blok.summerLotteryEndedVariant?.[0]?.title || undefined"
			:subtitle="!isLotteryActive && blok.summerLotteryEndedVariant?.[0]?.subtitle || undefined"
			:class="!isLotteryActive && 'grayscale'"
			class="mb-2"
		/>
		<LazyStickyAnchorNav
			v-if="isLotteryActive"
			:blok="blok"
			:list="findAnchorIn"
			center-nav
			@tab-click="trackTabClick"
		/>

		<div class="space-y-section">
			<template v-if="isLotteryActive">
				<StoryblokComponent
					v-for="item in blok.aboutSummerLottery"
					:key="item._uid"
					:blok="item"
				/>
				<StoryblokComponent
					v-for="item in blok.howToJoin"
					:key="item._uid"
					:blok="item"
				/>
				<StoryblokComponent
					v-for="item in blok.receiptRegistrationOptions"
					:key="item._uid"
					:blok="item"
				/>
				<StoryblokComponent
					v-for="item in blok.onlineReceiptRegistration"
					:key="item._uid"
					:blok="item"
					:lottery-id="blok.lotteryId"
				/>
				<StoryblokComponent
					v-for="item in blok.listOfPartners"
					:key="item._uid"
					:blok="item"
				/>
			</template>
			<template v-else>
				<StoryblokComponent
					v-for="item in blok.summerLotteryEndedVariant"
					:key="item._uid"
					:blok="item"
				/>
			</template>
		</div>
	</main>
</template>

<script setup lang="ts">
	import {useGtm} from '@gtm-support/vue-gtm';
	import {isWithinInterval, parseISO} from 'date-fns';
	import useSeoSettings from '~/composables/useSeoSettings';
	import type {PageTypeSummerLotteryStoryblok} from '@/storyblok/types';

	interface Props {
		blok: PageTypeSummerLotteryStoryblok
	}

	const props = defineProps<Props>();

	const findAnchorIn = ref(['aboutSummerLottery', 'howToJoin', 'receiptRegistrationOptions', 'onlineReceiptRegistration', 'summerLotteryEndedVariant', 'listOfPartners']);

	const isLotteryActive = computed(() => {
		const today = new Date();
		const startDate = parseISO(props.blok.lotteryStart);
		const endDate = parseISO(props.blok.lotteryEnd);
		return isWithinInterval(today, {start: startDate, end: endDate});
	});

	const gtm = useGtm();

	function trackTabClick(tab: {label: string; anchor: string}) {
		gtm?.push({
			event: 'click',
			type: 'tab',
			text: tab.label,
			target: tab.anchor,
			page_type: 'competition',
			content_group: 'competition_onair',
		});
	}

	useSeoSettings(props.blok.seoSettings?.[0]);
</script>
